import React from "react";
import FormattedDate from "./FormattedDate";
import WeatherTemperature from "./WeatherTemperature";
import WeatherIcon from "./WeatherIcon";

export default function WeatherInfo(props) {
  return (
    <div className="WeatherInfo">
      <h1 className="text-capitalize">{props.data.city}</h1>
      <ul className="text-capitalize">
        <li>
          <FormattedDate date={props.data.date} />
        </li>
      </ul>

      <div className="row mb-4">
        <div className="col-6">
          <div>
            <WeatherIcon icon={props.data.icon} />

            <div className="float-end">
              <WeatherTemperature celsius={props.data.temperature} />
            </div>
          </div>
        </div>

        <div className="col-6 precipitation">
          <div className="text-capitalize">
            Weather: {props.data.description}{" "}
            <span id="weather-description"></span>
          </div>
          <div>
            Humidity: {props.data.humidity}
            <span id="humidity"></span>%
          </div>
          <div>
            Wind: {props.data.wind} Km/h<span id="wind"></span>
          </div>
        </div>

        <br />
      </div>
    </div>
  );
}
